export const spinnerDarkColor = '#414042';
